import styled from "styled-components";

type HeaderProps = {
  bg?: string;
  sectionHeight?: number;
  navmenuBg?: string;
}

export const HeaderSection = styled.section<HeaderProps>`
  display: flow-root;
  min-height: ${({sectionHeight}) => `${sectionHeight}vh`};
  background-image: url(${({bg}) => bg});
  background-repeat: no-repeat;
  background-position: top;
  background-attachment: fixed;
  background-size: cover;
  box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, .01);
  padding: ${({theme}) => theme.location.location().pathname === "/" ? "2rem 0" : "0"};

  hr {
    margin-top: 20px;
  }
`;

export const HeaderElement = styled.header<HeaderProps>`
  background-color: ${({navmenuBg}) => navmenuBg};
  padding: ${({theme}) => theme.location.location().pathname !== "/" ? "2rem 0" : "0"};
`

export const PageHeader = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 2%;
  flex: 1;
`;
